import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookiePolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white text-gray-800">
      {/* Header */}
      <div data-on-dark="true" className="bg-[#6C63FF] text-white py-12 px-6">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="text-white hover:text-white text-sm mb-4 inline-block opacity-90 hover:opacity-100">← Torna a Yollo</Link>
          <h1 className="text-3xl font-bold text-white">Cookie Policy</h1>
          <p className="text-white mt-2 text-sm">Ultimo aggiornamento: maggio 2026 — ai sensi del D.Lgs. 196/2003 e del Provvedimento Garante n. 229/2014</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12 space-y-10 text-[15px] leading-relaxed">

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">1. Cosa sono i Cookie</h2>
          <p>I cookie sono piccoli file di testo che i siti web visitati dall'utente inviano al suo terminale (computer, tablet, smartphone), dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla successiva visita. Consentono al sito di ricordare le azioni e le preferenze dell'utente nel tempo.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">2. Cookie utilizzati da yollo.me</h2>

          {/* Tecnici */}
          <div className="mt-4">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="px-2 py-1 rounded-full bg-green-100 text-green-700 text-xs font-bold">TECNICI</span>
              <span className="text-sm text-gray-600">Sempre attivi — non richiedono consenso</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="text-left p-3 border border-gray-200 font-semibold">Nome</th>
                    <th className="text-left p-3 border border-gray-200 font-semibold">Finalità</th>
                    <th className="text-left p-3 border border-gray-200 font-semibold">Durata</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["yollo_token", "Token di autenticazione JWT per sessione utente loggato", "Sessione / 7 giorni"],
                    ["yollo_device_token", "Identificazione dispositivo per accesso operatori", "1 anno"],
                    ["yollo_locale_id", "Memorizza il locale selezionato dall'utente", "Sessione"],
                  ].map(([nome, fin, dur], i) => (
                    <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
                      <td className="p-3 border border-gray-200 font-mono text-xs">{nome}</td>
                      <td className="p-3 border border-gray-200">{fin}</td>
                      <td className="p-3 border border-gray-200 text-gray-500">{dur}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Analitici */}
          <div className="mt-6">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="px-2 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs font-bold">ANALITICI</span>
              <span className="text-sm text-gray-600">Richiedono consenso (terza parte)</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="text-left p-3 border border-gray-200 font-semibold">Nome</th>
                    <th className="text-left p-3 border border-gray-200 font-semibold">Provider</th>
                    <th className="text-left p-3 border border-gray-200 font-semibold">Finalità</th>
                    <th className="text-left p-3 border border-gray-200 font-semibold">Durata</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["_ga", "Google Analytics 4", "Identifica sessione utente unico (anonimizzato)", "2 anni"],
                    ["_ga_3P5GPX5H2H", "Google Analytics 4", "Distingue le sessioni per la proprietà GA4", "2 anni"],
                    ["_gid", "Google Analytics 4", "Distingue utenti distinti nelle ultime 24 ore", "24 ore"],
                    ["ph_*", "PostHog", "Analisi comportamento prodotto (anonimizzato)", "1 anno"],
                  ].map(([nome, prov, fin, dur], i) => (
                    <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
                      <td className="p-3 border border-gray-200 font-mono text-xs">{nome}</td>
                      <td className="p-3 border border-gray-200 text-gray-600">{prov}</td>
                      <td className="p-3 border border-gray-200">{fin}</td>
                      <td className="p-3 border border-gray-200 text-gray-500">{dur}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-xs text-gray-500 mt-2">Google Analytics è configurato con anonimizzazione dell'IP. I dati non sono associati a informazioni personali identificabili.</p>
          </div>

          {/* Terze parti funzionali */}
          <div className="mt-6">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-bold">FUNZIONALI DI TERZE PARTI</span>
              <span className="text-sm text-gray-600">Attivati solo se si usa la funzionalità</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="text-left p-3 border border-gray-200 font-semibold">Provider</th>
                    <th className="text-left p-3 border border-gray-200 font-semibold">Finalità</th>
                    <th className="text-left p-3 border border-gray-200 font-semibold">Info</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Stripe", "Gestione pagamenti e abbonamenti. Stripe può impostare cookie sul dominio checkout.stripe.com.", "stripe.com/cookie-settings"],
                  ].map(([prov, fin, link], i) => (
                    <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
                      <td className="p-3 border border-gray-200 font-semibold">{prov}</td>
                      <td className="p-3 border border-gray-200">{fin}</td>
                      <td className="p-3 border border-gray-200"><a href={`https://${link}`} target="_blank" rel="noreferrer" className="text-[#6C63FF] underline text-xs">{link}</a></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">3. Come Gestire i Cookie</h2>
          <p>È possibile controllare e/o eliminare i cookie in qualsiasi momento tramite le impostazioni del browser:</p>
          <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { browser: "Google Chrome", url: "https://support.google.com/chrome/answer/95647" },
              { browser: "Mozilla Firefox", url: "https://support.mozilla.org/it/kb/Gestione dei cookie" },
              { browser: "Apple Safari", url: "https://support.apple.com/it-it/guide/safari/sfri11471/mac" },
              { browser: "Microsoft Edge", url: "https://support.microsoft.com/it-it/microsoft-edge" },
            ].map((b, i) => (
              <a key={i} href={b.url} target="_blank" rel="noreferrer"
                className="flex items-center gap-2 p-3 rounded-lg border border-gray-200 hover:border-[#6C63FF] hover:bg-purple-50 transition-colors text-sm">
                <span className="font-semibold text-gray-800">{b.browser}</span>
                <span className="text-[#6C63FF] ml-auto text-xs">Guida →</span>
              </a>
            ))}
          </div>
          <p className="mt-4 text-sm text-gray-600">
            <strong>Attenzione:</strong> disabilitare i cookie tecnici può compromettere il corretto funzionamento della piattaforma Yollo (login, sessione, ecc.).
          </p>
          <p className="mt-2 text-sm text-gray-600">
            Per disabilitare il tracciamento di Google Analytics su tutti i siti: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer" className="text-[#6C63FF] underline">Google Analytics Opt-out Add-on</a>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">4. Revoca del Consenso</h2>
          <p>Il consenso prestato per i cookie analitici può essere revocato in qualsiasi momento eliminando i cookie dal browser o utilizzando gli strumenti messi a disposizione dai singoli provider. La revoca del consenso non pregiudica la liceità del trattamento effettuato prima della revoca.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">5. Titolare del Trattamento</h2>
          <div className="p-4 bg-gray-50 rounded-xl border border-gray-200 text-sm">
            <p><strong>Luchapp S.r.l.</strong> — Via Tucci 4, 04100 Latina (LT)</p>
            <p>P.IVA: 03368240598</p>
            <p>Email: <a href="mailto:luchappsrls@legalmail.it" className="text-[#6C63FF]">luchappsrls@legalmail.it</a></p>
          </div>
          <p className="mt-3">Per qualsiasi richiesta relativa all'utilizzo dei cookie su questo sito, puoi contattarci all'indirizzo sopra indicato.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">6. Modifiche alla Cookie Policy</h2>
          <p>La presente Cookie Policy può essere soggetta ad aggiornamenti periodici, anche in relazione a eventuali modifiche normative. La versione aggiornata sarà sempre disponibile su questa pagina con la data di revisione.</p>
        </section>

        <div className="border-t border-gray-200 pt-8 text-sm text-gray-500 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <span>© 2026 Luchapp S.r.l. — Tutti i diritti riservati</span>
          <div className="flex gap-4">
            <Link to="/privacy" className="text-[#6C63FF] hover:underline">Privacy Policy</Link>
            <Link to="/" className="hover:underline">Torna a Yollo</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
